
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from "./Footer";   // adjust path if needed
import emailjs from "@emailjs/browser"; // ✅ EmailJS import

// EmailJS init (एकदा component mount होताना)
emailjs.init("ASvyy0reI1mYzw6hn"); // तुझी public key (CareerHome प्रमाणे)

const ContactUs = () => {
  const [lang, setLang] = useState("en");

useEffect(() => {
  const savedLang = localStorage.getItem("lang");
  if (savedLang) setLang(savedLang);
}, []);

const changeLang = (l) => {
  setLang(l);
  localStorage.setItem("lang", l);
};

const t = {
  en: {
    title: "Get in Touch",
    subtitle: "We’d Love To Help You",
    visit: "Visit us on",
    call: "Call us",
    mail: "Mail us",
    formTitle: "Don’t Hesitate To Send Your Message To Us",
    name: "Your Name",
    email: "Your Email Address",
    phone: "Contact Number",
    location: "Location",
    message: "Your Message",
    send: "Send Message",
    quick: "Quick Links",
    about: "About Us",
    services: "Services",
    gallery: "Gallery",
    contact: "Contact Us",
    follow: "Follow Us",
    rights: "All Rights Reserved"
  },

  mr: {
    title: "संपर्क साधा",
    subtitle: "आम्हाला तुमची मदत करायला आवडेल",
    visit: "आम्हाला येथे भेट द्या",
    call: "आम्हाला कॉल करा",
    mail: "आम्हाला ईमेल करा",
    formTitle: "आम्हाला तुमचा संदेश पाठवायला अजिबात संकोच करू नका",
    name: "तुमचे नाव",
    email: "तुमचा ईमेल पत्ता",
    phone: "संपर्क क्रमांक",
    location: "स्थान",
    message: "तुमचा संदेश",
    send: "संदेश पाठवा",
    quick: "झटपट दुवे",
    about: "आमच्याबद्दल",
    services: "सेवा",
    gallery: "गॅलरी",
    contact: "संपर्क करा",
    follow: "आम्हाला फॉलो करा",
    rights: "सर्व हक्क राखीव"
  },

  hi: {
    title: "संपर्क करें",
    subtitle: "हमें आपकी सहायता करके खुशी होगी",
    visit: "हमसे यहाँ मिलें",
    call: "हमें कॉल करें",
    mail: "हमें ईमेल करें",
    formTitle: "हमें अपना संदेश भेजने में संकोच न करें",
    name: "आपका नाम",
    email: "आपका ईमेल पता",
    phone: "संपर्क नंबर",
    location: "स्थान",
    message: "आपका संदेश",
    send: "संदेश भेजें",
    quick: "त्वरित लिंक",
    about: "हमारे बारे में",
    services: "सेवाएँ",
    gallery: "गैलरी",
    contact: "संपर्क करें",
    follow: "हमें फॉलो करें",
    rights: "सर्वाधिकार सुरक्षित"
  }
};

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // EmailJS send - तुझ्या CareerHome प्रमाणे service + template
      const response = await emailjs.send(
        "service_7o2vscq",           // Service ID
        "template_tw2co8q",          // Template ID (तुझा जुना)
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          location: formData.location,
          message: formData.message,
          to_email: "info@globalcertification.com", // तुझ्या कंपनीचा email
        }
      );

      console.log("SUCCESS!", response.status, response.text);
      alert("Thank you! Your message has been sent successfully. We will get back to you soon.");

      // Form clear
      setFormData({
        name: "",
        email: "",
        phone: "",
        location: "",
        message: "",
      });
    } catch (error) {
      console.error("FAILED...", error);
      alert("Something went wrong. Please try again or email us directly at info@globalcertification.com");
    }
  };

  // तुझा जुना styles object जसाचा तसा
  const styles = {
    container: {
      fontFamily: "'Poppins', sans-serif",
      backgroundColor: "#fff",
      color: "#333",
      lineHeight: 1.6,
    },
    header: {
      backgroundImage:
        "url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1500&q=80')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      padding: "100px 20px",
      textAlign: "center",
      color: "#fff",
      position: "relative",
      overflow: "hidden",
    },
    headerTitle: {
      fontSize: "2.5rem",
      fontWeight: "600",
      margin: "0 0 10px 0",
      textShadow: "0 2px 8px rgba(0,0,0,0.4)",
    },
    contactInfo: {
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: "20px",
      margin: "40px 0",
      padding: "0 20px",
    },
    card: {
      backgroundColor: "#fff",
      borderRadius: "12px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
      padding: "25px 30px",
      width: "280px",
      textAlign: "center",
      transition: "all 0.3s ease",
      border: "1px solid #e9ecef",
    },
    cardHover: {
      transform: "translateY(-5px)",
      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
    },
    icon: {
      fontSize: "40px",
      color: "#0A1D56",
      marginBottom: "10px",
      filter: "drop-shadow(0 2px 6px rgba(10,29,86,0.2))",
    },
    formContainer: {
      maxWidth: "800px",
      margin: "0 auto 50px auto",
      padding: "30px",
      backgroundColor: "#f9f9f9",
      borderRadius: "12px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      border: "1px solid #e9ecef",
    },
    input: {
      width: "100%",
      padding: "12px",
      margin: "10px 0",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "16px",
      outline: "none",
      transition: "border 0.3s ease",
    },
    inputFocus: {
      borderColor: "#0A1D56",
      boxShadow: "0 0 0 3px rgba(10,29,86,0.1)",
    },
    button: {
      backgroundColor: "#0A1D56",
      color: "#fff",
      border: "none",
      padding: "12px 25px",
      borderRadius: "6px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      marginTop: "10px",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 12px rgba(10,29,86,0.3)",
    },
    buttonHover: {
      backgroundColor: "#FF7F50",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 18px rgba(255,127,80,0.4)",
    },
    map: {
      width: "100%",
      height: "400px",
      border: 0,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
    },
  };

  return (
    <div style={styles.container}>
      {/* LANGUAGE SWITCHER */}
      {/* <div className="lang-switcher">
        <button onClick={() => setLang("en")} className={lang === "en" ? "active" : ""}>English</button>
        <button onClick={() => setLang("hi")} className={lang === "hi" ? "active" : ""}>हिंदी</button>
        <button onClick={() => setLang("mr")} className={lang === "mr" ? "active" : ""}>मराठी</button>
      </div> */}
      {/* Header Banner */}
      <section style={styles.header}>
        <h1 style={styles.headerTitle}>{t[lang].title}</h1>
        <p>{t[lang].subtitle}</p>
      </section>

      {/* Contact Info Cards */}
      <div style={styles.contactInfo}>
        {/* Address Card */}
        <div
          style={styles.card}
          onMouseEnter={(e) =>
            Object.assign(e.currentTarget.style, styles.cardHover)
          }
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "";
            e.currentTarget.style.boxShadow = "";
          }}
        >
          <div style={styles.icon}>📍</div>
          <h3>{t[lang].visit}</h3>
          <p style={{ fontSize: "0.95rem", lineHeight: "1.6", color: "#555" }}>
            <strong>Global Certification</strong>
            <br />
            Plot No. 15A, Navjeevan Colony,
            <br />
            Wardha Road, Narendra Nagar,
            <br />
            Nagpur - 440015
          </p>
        </div>

        {/* Phone Card */}
        <div
          style={styles.card}
          onMouseEnter={(e) =>
            Object.assign(e.currentTarget.style, styles.cardHover)
          }
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "";
            e.currentTarget.style.boxShadow = "";
          }}
        >
          <div style={styles.icon}>📞</div>
          <h3>{t[lang].call}</h3>
          <p
            style={{
              fontSize: "1.1rem",
              fontWeight: "600",
              color: "#0A1D56",
            }}
          >
            +91 9975797462
          </p>
        </div>

        {/* Email Card */}
        <div
          style={styles.card}
          onMouseEnter={(e) =>
            Object.assign(e.currentTarget.style, styles.cardHover)
          }
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "";
            e.currentTarget.style.boxShadow = "";
          }}
        >
          <div style={styles.icon}>📧</div>
          <h3>{t[lang].mail}</h3>
          <p
            style={{
              fontSize: "1rem",
              color: "#0A1D56",
              fontWeight: "500",
            }}
          >
            info@globalcertification.com
          </p>
        </div>
      </div>

      {/* Contact Form - आता EmailJS ने */}
      <div style={styles.formContainer}>
        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            color: "#0A1D56",
          }}
        >
          {t[lang].formTitle}
        </h2>
        <form onSubmit={handleSubmit}>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            style={styles.input}
            type="text"
            placeholder={t[lang].name}
            required
          />
          <input
            name="email"
            value={formData.email}
            onChange={handleChange}
            style={styles.input}
            type="email"
            placeholder={t[lang].email}
            required
          />
          <input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            style={styles.input}
            type="text"
            placeholder={t[lang].phone}
          />
          <input
            name="location"
            value={formData.location}
            onChange={handleChange}
            style={styles.input}
            type="text"
            placeholder={t[lang].location}
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            style={{ ...styles.input, height: "100px", resize: "none" }}
            placeholder={t[lang].message}
          ></textarea>

          <button
            type="submit"
            style={styles.button}
            onMouseEnter={(e) =>
              Object.assign(e.currentTarget.style, styles.buttonHover)
            }
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#0A1D56";
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(10,29,86,0.3)";
            }}
          >
            {t[lang].send}
          </button>
        </form>
      </div>

      {/* Google Map - unchanged */}
      <div style={{ padding: "0 20px 40px" }}>
        <iframe
          title="Global Certification Office - Plot No. 15A, Navjeevan Colony, Wardha Road, Narendra Nagar, Nagpur"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.743850987142!2d79.07163057589177!3d21.12830278054358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c1a8f3a5c8e7%3A0x9c9e5a3b1f2d8e1a!2sPlot%20No.%2015A%2C%20Navjeevan%20Colony%2C%20Wardha%20Rd%2C%20Narendra%20Nagar%2C%20Nagpur%2C%20Maharashtra%20440015!5e0!3m2!1sen!2sin!4v1698412300000!5m2!1sen!2sin"
          style={styles.map}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      {/* ✅ FOOTER HERE */}
      <footer className="footer">
  <div className="footer-grid">

    <div className="footer-col">
      <h4>Global Certification</h4>
      <p>
        15A, Navjivan Colony, Wardha Road,<br />
        Narendra Nagar, Nagpur - 440015
      </p>
    </div>

    <div className="footer-col">
      <h4>{t[lang].quick}</h4>

      <Link to="/about-us" className="f-link">{t[lang].about}</Link>
      <Link to="/services-iso-standards" className="f-link">{t[lang].services}</Link>
      <Link to="/gallery" className="f-link">{t[lang].gallery}</Link>
      <Link to="/contact-us" className="f-link">{t[lang].contact}</Link>
    </div>

    <div className="footer-col">
      <h4>{t[lang].follow}</h4>
      <p>Facebook | LinkedIn | YouTube</p>
    </div>

  </div>

  <div className="copyright">
     © {new Date().getFullYear()} Global Certification. {t[lang].rights}
  </div>
</footer>
      
<style jsx>
{`
/* ==================== FOOTER (SHORTER BOXES) ==================== */
.footer {
  background: linear-gradient(135deg, #0A1D56, #0f2a5e);
  color: #ddd;
  padding: 3rem 2rem 1.5rem;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto 1.5rem;
}

.footer-col {
  min-height: auto;
}

.footer h4 {
  color: #fff;
  margin-bottom: 0.8rem;
  font-size: 1.05rem;
  padding-bottom: 0.4rem;
}

.footer h4::after {
  width: 35px;
  height: 2.5px;
}

.f-link {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 0.92rem;
  color: #ccc;
}

.copyright {
  font-size: 0.88rem;
  padding-top: 1.2rem;
}
  
.lang-switcher {
  display: inline-flex;
  gap: 8px;
  background: #f1f5f9;
  padding: 6px;
  border-radius: 50px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}

/* Buttons */
.lang-switcher button {
  border: none;
  background: transparent;
  padding: 8px 14px;
  border-radius: 30px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  transition: all 0.3s ease;
}

/* Hover effect */
.lang-switcher button:hover {
  background: #e2e8f0;
  color: #000;
}

/* Active button */
.lang-switcher button.active {
  background: linear-gradient(135deg, #00bcd4, #2196f3);
  color: #fff;
  font-weight: 600;
  box-shadow: 0 3px 8px rgba(0, 188, 212, 0.4);
}

/* Click effect */
.lang-switcher button:active {
  transform: scale(0.95);
}

/* Responsive */
@media (max-width: 480px) {
  .lang-switcher {
    gap: 4px;
    padding: 4px;
  }

  .lang-switcher button {
    padding: 6px 10px;
    font-size: 12px;
  }
}
`}
</style>
    </div>
  );
};

export default ContactUs;